import type { AdminRole } from '@/lib/api-admin';

export const CMS_ROUTE_ROLES: ReadonlyArray<AdminRole> = ['SUPER_ADMIN', 'OPS_ADMIN'];
